import { useState } from "react";
import { message } from "antd";
import { ButtonComponent } from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { getFlowReq } from "../masterManagement/system/components/requestFlow/requests";
import ChangeRequestFlow from "../masterManagement/system/components/requestFlow/components/ChangeRequestFlow";
import { checkPermissions } from "../../wrappers/commonFunctions";

const CompanyRequestFlowButton = ({
  typeId,
  text = "Change Approval Flow",
  forNodeId = null,
  forEmployeeId = "",
  forEmploymentId = "",
}) => {
  const [loading, setLoading] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  // if (!checkPermissions("requestFlow")) {
  //   return null;
  // }

  const requestFlow = {
    company_id: localStorage.getItem("company_id") ? localStorage.getItem("company_id") : 1,
    type_id: typeId,
    for_node_id: forNodeId,
    for_employee_id: forEmployeeId,
    for_employment_id: forEmploymentId,
  };

  const onOpen = () => {
    makeRequest(setLoading, getFlowReq, { request_flow: requestFlow }, onSuccess, onError);
  };

  const onSuccess = (response) => {
    setChildComponent(
      <ChangeRequestFlow
        record={ response }
        requestFlow={ requestFlow }
        onCompleted={ onCompleted }
      />
    );
  };

  const onCompleted = () => {
    setChildComponent(null);
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
  };

  return (
    <>
      { childComponent }
      <ButtonComponent text={ text } type="primary" onClick={ onOpen } loading={ loading } />
    </>
  );
};

export default CompanyRequestFlowButton;
